import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import showMoreIcon from "@/assets/icons/svg/down-arrow-circle-industry.svg";
import showLessIcon from "@/assets/icons/svg/up-arrow-circle-industry.svg";
import { Link } from "react-router-dom";

const RegionsAndIndustries = ({ props }) => {
  const { t } = useTranslation();
  const [regionsExpanded, setRegionsExpanded] = useState(false);
  const [industriesExpanded, setIndustriesExpanded] = useState(false);
  const regionsMoreRef = useRef<HTMLDivElement>(null);
  const IndustriesMoreRef = useRef<HTMLDivElement>(null);
  const [industriesItemsToShow, setIndustriesItemsToShow] = useState(Number(t("companyInformation.industriesItemsToShow"))); 
  const [regionsItemsToShow, setRegionsItemsToShow] = useState(Number(t("companyInformation.regionsItemsToShow"))); 
  const viewMoreLabel = t("industryAnalysis.industryCountry.viewMoreLabel");
  const viewLessLabel = t("industryAnalysis.industryCountry.viewLessLabel");


  useEffect(() => {
    if(relatedIndustriesArray.length <= industriesItemsToShow) {
      setIndustriesItemsToShow(relatedIndustriesArray.length);
    }
  }, []);

  const handleIndustriesViewMoreLess = () => {
    if(industriesExpanded) {
      window.scrollTo({
        top: IndustriesMoreRef.current?.offsetTop,
        behavior: 'smooth'
      }); 
    }
    setIndustriesExpanded(!industriesExpanded);
  };

  useEffect(() => {
    if(companyInformationGeos.length <= regionsItemsToShow) {
      setRegionsItemsToShow(companyInformationGeos.length);
    }
  }, []);

  const handleRegionsViewMoreLess = () => {
    if(regionsExpanded) {
      window.scrollTo({
        top: regionsMoreRef.current?.offsetTop,
        behavior: 'smooth'
      }); 
    }
    setRegionsExpanded(!regionsExpanded);
  };

  // Regions related data
  const { industryPropertiesTitle, companyInformationGeos, redirection } =
    props;
  const redirectedUrl = `${redirection.split(".")[0]}.${
    redirection.split(".")[1]
  }`;

  // Industries related data
  const { relatedIndustries } = props;
  // Conversion from object to Array for iteration and then sorting
  const relatedIndustriesArray = Object.entries(relatedIndustries)
    .map(([key, value]) => ({ key, value }))
    .sort((a, b) => a.key.localeCompare(b.key));

  return (
    <>
      {companyInformationGeos && companyInformationGeos.length > 0 && (
        <div className="industryGeoVTwoWrapper">
          <div className="container">
            <div className="title">
              {industryPropertiesTitle}{" "}
              {t("companyInformation.companiesInthisTown")}
            </div>

            <div className="locationResults text-center text-md-start spacing-ml-8" ref={regionsMoreRef}>
              {regionsExpanded ? companyInformationGeos.map((data) => (
                <div className="col-6 col-md-3 data pad-rlb-0 display-inline-block">
                  <Link
                    className="sideLink companyName"
                    to={`/business-directory/${redirectedUrl}.${data.href}.html`}
                  >
                    {" "}
                    {data["name"]?.replaceAll("&nbsp;", " ")}
                    <span className="number-countries">
                      {" "}
                      ({data["quantity"]})
                    </span>
                  </Link>
                </div>
              )) : companyInformationGeos.slice(0, regionsItemsToShow).map((data) => (
                <div className="col-6 col-md-3 data pad-rlb-0 display-inline-block">
                  <Link
                    className="sideLink companyName"
                    to={`/business-directory/${redirectedUrl}.${data.href}.html`}
                  >
                    {" "}
                    {data["name"]?.replaceAll("&nbsp;", " ")}
                    <span className="number-countries">
                      {" "}
                      ({data["quantity"]})
                    </span>
                  </Link>
                </div>
              ))}
            </div>
            <button
              className="show-more link viewMore text-decoration-none"
              onClick={handleRegionsViewMoreLess}
              
            >
              {companyInformationGeos && companyInformationGeos.length > regionsItemsToShow ? <>
                {regionsExpanded ? viewLessLabel : viewMoreLabel}{" "}
                <img
                  src={regionsExpanded ? showLessIcon : showMoreIcon}
                  className="viewMoreLessIcon"
                />
              </>: <></>}
            </button>
          </div>
        </div>
      )}

      <div className="industryRelatedVTwoWrapper">
      {relatedIndustriesArray &&  relatedIndustriesArray.length > 0 && <div className="container">
           <div className="title">
            {" "}
            {t("companyInformation.relatedIndustries")}
          </div>

          <div className="locationResults spacing-ml-8" ref={IndustriesMoreRef}>
            {industriesExpanded ? relatedIndustriesArray.map(({ key, value }) => (
              <div className="col-6 col-md-3 p-2 p-md-0 data pad-rlb-0 display-inline-block linkContentName">
                <Link
                  className="sideLink link-content companyName"
                  to={`/business-directory/industry-analysis.${value}.html`}
                >
                  {key}
                </Link>
              </div>
            )) : relatedIndustriesArray.slice(0, industriesItemsToShow).map(({ key, value }) => (
              <div className="col-6 col-md-3 data p-2 p-md-0 pad-rlb-0 display-inline-block linkContentName">
                <Link
                  className="sideLink link-content companyName"
                  to={`/business-directory/industry-analysis.${value}.html`}
                >
                  {key}
                </Link>
              </div>
            ))}
          </div>
          <div className="viewMoreButton">
          <button
              className="show-more link viewMore text-decoration-none"
              onClick={handleIndustriesViewMoreLess}
            >
              {relatedIndustriesArray && relatedIndustriesArray.length > industriesItemsToShow ? <>
                {industriesExpanded ? viewLessLabel : viewMoreLabel}{" "}
                <img
                  src={industriesExpanded ? showLessIcon : showMoreIcon}
                  className="viewMoreLessIcon"
                />
              </>: <></>}
          </button>
          </div>
        </div> }
      </div>
    </>
  );
};

export default RegionsAndIndustries;
